import { mapGetters, mapMutations } from "vuex";
import alertHelper from "@/helper/AlertHelper";
import Common from "@/common";

export const indirectGroupMixin = {
  data() {
    return {
      paymentId: "",
      querySecret: "",
      offlineGateways: [
        {
          page: "/ata",
          type: "account",
          imgSrc: require("@/assets/images/account-to-account.png"),
          translationKey: "accountToAccount",
        },

        {
          type: "card",
          page: "/ctc",
          imgSrc: require("@/assets/images/CardToCardOn.png"),
          translationKey: "cardToCard",
        },
        // Add more items as needed
      ],
      enabledMethods: [],
      apiRequestPending: false,
    };
  },
  computed: {
    ...mapGetters([
      "getVersion",
      "getGlobalApiRequestPending",
      "getCryptoGroupActiveGateways",
      "getCallBackUrl",
    ]),
  },
  methods: {
    ...mapMutations([
      "setStepperPage",
      "setIsCompName",
      "setOfflineCards",
      "setSelectedOfflineGateway",
    ]),

    handlePageChange(page) {
      const queryId = this.$route.query.id;
      const querySecret = this.$route.query.s;
      this.$router.push(`${page}?id=${queryId}&s=${querySecret}`);
    },
    showDisabled() {
      alertHelper.infoAlert(
        "",
        "در حال حاضر این روش پرداخت غیر فعال می باشد، از روشهای دیگری استفاده کنید"
      );
    },
    cancelPayment() {
      let paymentId = this.$route.query.id;
      const callBackUrl = this.getCallBackUrl;
      alertHelper.loadingAlert();
      if (callBackUrl) {
        window.location.href = Common.createCallback(callBackUrl, paymentId, 0);
      } else {
        this.$http.delete(`payments/${paymentId}`).then((result) => {
          window.location.href = Common.createCallback(
            result.data.data.callback_url,
            paymentId,
            0
          );
        });
      }
    },
    /*filterAccountTransfers(accounts, type) {
      const queryId = this.$route.query.id;
      const querySecret = this.$route.query.s;

      let accountTransferArray = [];
      accounts.forEach((account) => {
        if (account.is_account_transfer === 1 && type === "account") {
          accountTransferArray.push(account);
        } else if (account.is_card_transfer === 1 && type === "card") {
          accountTransferArray.push(account);
        }

        if (type === "account") {
          this.$router.push(`${"/ata"}?id=${queryId}&s=${querySecret}`);
        } else if (type === "card") {
          this.$router.push(`${"/ctc"}?id=${queryId}&s=${querySecret}`);
        }
      });
      return accountTransferArray;
    },*/
    /*getOfflineAccounts(account) {
      this.getOfflineAccountsList(account);
    },*/
    selectOfflineMethod(method) {
      const queryId = this.$route.query.id;
      const querySecret = this.$route.query.s;
      if (method.type === "account") {
        this.$router.push(`${"/ata"}?id=${queryId}&s=${querySecret}`);
      } else if (method.type === "card") {
        this.$router.push(`${"/ctc"}?id=${queryId}&s=${querySecret}`);
      }
    },
    getOfflineAccountsList() {
      const queryId = this.$route.query.id;
      this.apiRequestPending = true;
      alertHelper.loadingAlert();
      this.$http.get(`payments/${queryId}/offline-accounts-list`).then(
        (result) => {
          alertHelper.closeAlert();
          const resultData = result.data.data;
          this.setOfflineCards(resultData);
          for (const eachAccount of resultData) {
            if (
              eachAccount.is_card_transfer === 1 &&
              !this.enabledMethods.includes("card")
            )
              this.enabledMethods.push("card");
            if (
              eachAccount.is_account_transfer === 1 &&
              !this.enabledMethods.includes("account")
            )
              this.enabledMethods.push("account");
          }
          this.apiRequestPending = false;
        },
        (error) => {
          this.apiRequestPending = false;

          alertHelper.apiErrorAlert("", error.body.message);
        }
      );
    },
  },
  created() {
    this.getOfflineAccountsList();
    this.setIsCompName("indirectGroup");
  },
};
